import React from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';

const TermsAndConditions = () => {
  return (
  <>
    <Header />
    <Container className="mt-5 bg-white p-4 border border-1 mb-5 shadow p-3 mb-5 bg-body rounded">
      <Row className="justify-content-center">
        <Col lg={10}>
          <h1 className="text-center">Terms and Conditions</h1>
          <p>
            Welcome to CodeInputs.com. By accessing or using our website, you
            agree to comply with and be bound by the following terms and
            conditions. If you do not agree with these terms, please do not use
            our website.
          </p>

          <h3 className="mt-3 mb-3">1. Acceptance of Terms</h3>
          <p>
            By using CodeInputs.com, you acknowledge that you have read,
            understood, and agree to be bound by these Terms and Conditions.
          </p>

          <h3 className="mt-3 mb-3">2. Use of Website</h3>
          <ul>
            <li>
              The content provided on CodeInputs.com is for informational
              purposes only.
            </li>
            <li>
              You agree not to use the website for any unlawful or prohibited
              activities.
            </li>
            <li>
              We reserve the right to modify or discontinue any part of the
              website at any time without notice.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">3. Intellectual Property</h3>
          <ul>
            <li>
              All content, including text, graphics, logos, and code, is the
              property of CodeInputs.com and is protected under copyright laws.
            </li>
            <li>
              You may not reproduce, distribute, or modify any content from this
              website without prior written permission.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">4. User-Generated Content</h3>
          <ul>
            <li>
              If you submit any comments, suggestions, or other materials to our
              website, you grant us a non-exclusive, royalty-free license to
              use, reproduce, and distribute such content.
            </li>
            <li>
              You are solely responsible for the content you submit, ensuring it
              does not violate any laws or third-party rights.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">5. Third-Party Links</h3>
          <ul>
            <li>
              Our website may contain links to third-party websites for your
              convenience.
            </li>
            <li>
              We do not endorse or assume responsibility for the content,
              privacy policies, or practices of any third-party websites.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">6. Limitation of Liability</h3>
          <ul>
            <li>
              CodeInputs.com shall not be held liable for any direct, indirect,
              incidental, or consequential damages resulting from your use of
              the website.
            </li>
            <li>
              We do not guarantee the accuracy, completeness, or reliability of
              any content on our website.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">7. Privacy Policy</h3>
          <ul>
            <li>
            Your use of CodeInputs.com is also governed by our Privacy Policy,
            available at <a href="[Insert Privacy Policy URL]">Privacy Policy</a>.
          </li>
        </ul>

          <h3 className="mt-3 mb-3">8. Changes to Terms & Conditions</h3>
          <ul>
            <li>
              We reserve the right to update or modify these terms at any time
              without prior notice.
            </li>
            <li>
              Your continued use of the website after any changes constitutes
              acceptance of the new terms.
            </li>
          </ul>

          <h3 className="mt-3 mb-3">9. Governing Law</h3>
          <ul>
              <li>
                  These Terms and Conditions are governed by and constructed in
                  accordance with the laws of [Your Country/State], and any disputes
                  shall be resolved in the applicable courts.
              </li>
          </ul>

          <h3 className="mt-3 mb-3">10. Contact Information</h3>
          <p>If you have any questions about these Terms and Conditions, please contact us at:</p>
          <p><strong>Email:</strong> codeinputs@gmail.com</p>
          <p>
            <strong>Website:</strong> <a href="https://codeinputs.com">https://codeinputs.com</a>
          </p>

          <p>By using CodeInputs.com, you agree to these Terms and Conditions.</p>
        </Col>
      </Row>
    </Container>
    <Footer />
    </>
  );
};

export default TermsAndConditions;
